// ==========================================================================
// components/Emblem.tsx — the family crest, drawn in the theme's colour (FF-058)
//   The same drawing as public/emblem.svg (the Gemini emblem, 9 Oct), but the
//   swash, heart, leaves and parents read --em-* from theme.css, so the crest
//   is rose, lilac, forest or blue with the login's theme. The child stays
//   gold in every theme. public/emblem.svg stays rose for the icon and favicon.
// ==========================================================================
import { useId } from "react";

const c = (v: string, a = 1) => `rgb(var(--em-${v}) / ${a})`;

export default function Emblem({ className = "", title }: { className?: string; title?: string }) {
  const id = useId().replace(/:/g, "");
  return (
    <svg viewBox="120 70 260 270" fill="none" className={className} role={title ? "img" : undefined} aria-hidden={title ? undefined : true} aria-label={title}>
      <defs>
        <linearGradient id={`cr${id}`} x1="120" y1="80" x2="380" y2="340" gradientUnits="userSpaceOnUse">
          <stop offset="0%" style={{ stopColor: c("hi") }} />
          <stop offset="60%" style={{ stopColor: c("mid") }} />
          <stop offset="100%" style={{ stopColor: c("lo") }} />
        </linearGradient>
        <linearGradient id={`gd${id}`} x1="260" y1="230" x2="295" y2="310" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#E9C1A0" />
          <stop offset="100%" stopColor="#DCA57D" />
        </linearGradient>
      </defs>
      {/* Swash */}
      <path d="M 315 170 C 328 140 318 100 280 82 C 220 54 135 95 135 200 C 135 305 210 335 285 330 C 235 330 155 300 155 205 C 155 125 215 80 270 98 C 300 108 308 132 298 162 C 293 175 305 182 315 170 Z" fill={`url(#cr${id})`} />
      {/* Heart */}
      <path d="M 268 135 C 268 130 263 125 258 125 C 253 125 250 128 250 131 C 250 128 247 125 242 125 C 237 125 232 130 232 135 C 232 144 245 152 250 156 C 255 152 268 144 268 135 Z" style={{ fill: c("mid") }} />
      {/* Leaf sprig */}
      <path d="M 270 325 C 315 310 355 255 365 170 C 352 195 345 220 330 240" style={{ stroke: c("hi") }} strokeWidth="2.5" strokeLinecap="round" fill="none" />
      <ellipse cx="340" cy="190" rx="9" ry="16" transform="rotate(35 340 190)" style={{ fill: c("hi", 0.85) }} />
      <ellipse cx="365" cy="225" rx="8" ry="15" transform="rotate(50 365 225)" style={{ fill: c("mid", 0.75) }} />
      <ellipse cx="330" cy="245" rx="7" ry="14" transform="rotate(65 330 245)" style={{ fill: c("soft", 0.9) }} />
      <ellipse cx="355" cy="275" rx="7" ry="13" transform="rotate(75 355 275)" style={{ fill: c("mid", 0.75) }} />
      {/* Parent 1 */}
      <circle cx="195" cy="180" r="17" style={{ fill: c("mid") }} />
      <rect x="178" y="202" width="34" height="98" rx="17" style={{ fill: c("mid") }} />
      {/* Parent 2 */}
      <circle cx="233" cy="205" r="14.5" style={{ fill: c("hi") }} />
      <rect x="218.5" y="224" width="29" height="76" rx="14.5" style={{ fill: c("hi") }} />
      {/* Child */}
      <circle cx="264" cy="242" r="12.5" fill={`url(#gd${id})`} />
      <rect x="251.5" y="258" width="25" height="42" rx="12.5" fill={`url(#gd${id})`} />
    </svg>
  );
}
